import { 
  Box, 
  Typography, 
  Button 
} from '@mui/material';
import {
  Cancel as CancelIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';

const PaymentCancel = () => {
  
  const handleClose = () => {
    window.close();
  };

  const handleRetry = () => {
    // Cerrar popup y el padre debería recargar o mostrar los planes
    if (window.opener) {
      window.opener.postMessage('payment-cancelled', '*');
    }
    window.close();
  };

  return (
    <Box sx={{ 
      p: 4, 
      textAlign: 'center',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f5f5f5'
    }}>
      <CancelIcon sx={{ fontSize: 80, color: 'warning.main', mb: 2 }} />
      
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
        Pago cancelado
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 1 }}>
        No se procesó ningún cargo.
      </Typography>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Puedes intentar nuevamente cuando desees.
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
        <Button 
          variant="outlined" 
          onClick={handleClose}
          startIcon={<CancelIcon />}
        >
          Cerrar
        </Button>
        
        <Button 
          variant="contained" 
          onClick={handleRetry}
          startIcon={<ArrowBackIcon />}
        >
          Volver a planes
        </Button>
      </Box>
    </Box>
  );
};

export default PaymentCancel;